import { useEffect } from 'react';
import { getScrollableParent } from 'utils/scroll/scrollExpandedSectionIntoView';

type MutableRef<T> = { current: T };

export const useWheelScrollWhileDragging = (originRef: MutableRef<HTMLElement | null>, isDraggingRef: MutableRef<boolean>) => {
  useEffect(() => {
    const onWheel = (event: WheelEvent) => {
      if (!isDraggingRef.current) return;

      const scrollParent = getScrollableParent(originRef.current);
      if (!scrollParent) return;

      event.preventDefault();
      scrollParent.scrollBy({ left: event.deltaX, top: event.deltaY });
    };

    document.addEventListener('wheel', onWheel, { passive: false, capture: true });

    return () => document.removeEventListener('wheel', onWheel, { capture: true });
  }, [isDraggingRef, originRef]);
};
